/** Japanese – 日本語 */
export default {
  'nav.home': 'ホーム',
  'nav.seeDemo': 'デモを見る',
  'nav.howItWorks': '使い方',
  'nav.pricing': '料金',
  'nav.aboutUs': '会社概要',
  'nav.faqs': 'よくある質問',
  'nav.contact': 'お問い合わせ',
  'nav.careers': '採用情報',
  'nav.blog': 'ブログ',
  'nav.logIn': 'ログイン / 新規登録',
  'nav.getStarted': '始める',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': '月額$2から！',
  'hero.subscriptionsOnly': '( サブスクリプションのみ )',
  'hero.couponBannerText': '初回1000名様限定・終身10%オフクーポン！',
  'hero.couponSubscribedOnly': '(登録ユーザーのみ)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': '電子署名プラットフォーム · 月額$2からのプラン',
  'hero.bannerHeadlinePrefix': '「',
  'hero.bannerHeadlineMid': '」を今すぐ締結。',
  'hero.bannerHeadlineAccent': '',
  'hero.bannerCycleContracts': '契約',
  'hero.bannerCycleNDAs': 'NDA',
  'hero.bannerCycleProposals': '提案書',
  'hero.bannerCycleDocuments': 'ドキュメント',
  'hero.bannerDesc':
    'プロ品質の合意文書を作成し、電子署名で送信し、法的拘束力のある署名済みPDFを数分で受け取れます。あらゆるデバイスから利用可能です。',
  'hero.watchDemo': '使い方を見る',
  'hero.trustLocked': 'AES-256 暗号化',
  'hero.trustNoCard': 'カード不要',
  'hero.trustReady': '約2分で開始',
  'hero.landingShowMore': 'もっと見る',
  'hero.landingShowLess': '閉じる',
  'hero.tagline': '文書の作成・署名・送信をいちばん簡単に — 縛りなし',
  'hero.firebaseTopAria': 'セキュリティとホスティング（Google Firebase / Google Cloud）',
  'hero.topTrustListAria': 'セキュリティ、料金、署名、リマインダー、サポート',
  'hero.accDataSafeTitle': 'お客様のデータは安全です',
  'hero.accDataSafe1':
    'Google Firebase と Google Cloud 上で運用。世界中のアプリが信頼するエンタープライズ級インフラ',
  'hero.accDataSafe2': 'Google管理キーによる保存時AES-256暗号化でデータを保護',
  'hero.accDataSafe3': 'Googleの先進的セキュリティ基準に基づく認証とデータ処理',
  'hero.accDataSafe4': 'データを売却・共有しません。プライバシーを尊重します',
  'hero.accDataSafe5Before': 'データの保存・利用について透明性があります（',
  'hero.accDataSafe5After': 'をご覧ください）',
  'hero.accPricingTitle': 'シンプルで手頃な料金 · 隠れた費用なし',
  'hero.accPricing1': '数分でプロ品質の合意書を作成',
  'hero.accPricing2': '月額わずか$2からのプラン',
  'hero.accPricing3': '隠れた手数料や請求の驚きなし',
  'hero.accPricing4': '縛りなし · いつでも解約可能',
  'hero.accPricing5': 'フリーランス、スタートアップ、中小企業に最適',
  'hero.accPricing6': '最初の1通は無料で送信できます',
  'hero.accSigningTitle': '迅速かつ簡単な文書署名',
  'hero.accSigning1': '30種以上のテンプレートまたは独自ファイルに対応',
  'hero.accSigning2': '署名欄を数秒で追加・カスタマイズ',
  'hero.accSigning3': '複数の受信者に一括送信',
  'hero.accSigning4': 'テンプレートを保存して再利用',
  'hero.accSigning5': '受信者はアカウント不要で即署名',
  'hero.accSigning6': '送信前にライブプレビューで確認',
  'hero.accRemindersTitle': 'スマートリマインダーと追跡',
  'hero.accReminders1': '1日・3日・7日後の自動フォローアップ',
  'hero.accReminders2': '開封・署名時に即通知',
  'hero.accReminders3': '署名プロセスをリアルタイムで追跡',
  'hero.accReminders4': '手動での督促が不要に',
  'hero.accAnywhereTitle': 'どこからでも作業',
  'hero.accAnywhere1': 'PCでもスマホでもドキュメントにアクセス',
  'hero.accAnywhere2': 'どのデバイスからも送信・署名',
  'hero.accAnywhere3': 'オフィスでも外出先でも柔軟に',
  'hero.accSupportTitle': '信頼できるサポート',
  'hero.accSupport1': '迅速な対応の専任カスタマーサポート',
  'hero.accSupport2': '24時間以内の返信を目標',
  'hero.accSupport3': 'フィードバックに基づく継続的な改善',
  'hero.firebaseTrustPrivacyLink': 'プライバシーポリシー',
  'hero.firebaseTrustFineprintAfter':
    ' に保管、アクセス、お客様の権利について説明します。データを販売することはありません。',
  'hero.pill': '数秒で法的拘束力のある電子署名を送信',
  'hero.headline': 'フリーランサーと少人数チーム向けの最もシンプルな電子署名ツール',
  'hero.ctaPrimary': 'ドキュメントを作成 / アップロードして署名を依頼',
  'hero.ctaTrialSignup': '無料トライアルを開始',
  'hero.ctaFreeDocument': '無料トライアルを開始',
  'hero.ctaPrimaryNote': '7日間無料。カード登録が必要です。その後はキャンセルしない限り年額35ドルです。',
  'hero.subscriptionTeaserBefore': 'サブスクリプションは月額わずか ',
  'hero.subscriptionTeaserAfter': ' から！',
  'hero.createAccountTrialHeadline': '7日間の無料トライアルを開始',
  'hero.createAccountPromoCopy': 'コードをコピー',
  'hero.createAccountPromoCopied': 'コピーしました',
  'hero.createAccountPromoCodeAria': 'プロモーションコード：1か月無料トライアル',
  'hero.createAccountNote': 'プラン選択時のチェックアウトでご利用ください。',
  'hero.createAccountOfferLimit': '（ 先着1000名様限定のオファーです ）',
  'hero.desc': '個人やチームが、モダンな署名体験で契約書の作成・送付・管理を簡単に。',
  'hero.getStartedFree': '無料で始める',
  'hero.tryWithoutAccountButton': 'アカウントなしで試す',
  'hero.logInSignUp': 'ログイン / 新規登録',
  'hero.whyChooseUs': '選ばれる理由',
  'hero.stepsTitle': '作成、署名、受信',
  'hero.stepsSubtitle': '3つの簡単なステップでドキュメントを作成し、数分で署名できます。',
  'hero.step1Create': 'ドキュメントをアップロードまたは作成',
  'hero.step2Sign': '署名のため送信',
  'hero.step3Receive': '署名時に即座に通知を受け取る',
  'hero.benefit1': 'かんたん – 署名リンクやメールを数秒で送信',
  'hero.benefit2': '既存のPDFをアップロード、またはテキストを抽出してリッチテキストで編集',
  'hero.benefit3': 'PDFからテキストを抽出して編集',
  'hero.benefit4': '署名フィールドとレイアウトを数秒で作成',
  'hero.benefit5': '複数の宛先に同時送信',
  'hero.benefit7': 'リンクをコピーして誰でも送信',
  'hero.benefit8': 'テンプレートを作成・保存',
  'hero.benefit9': 'メール送信履歴を確認',
  'hero.benefit10': 'ライブプレビューと監査用PDF',
  'hero.benefit11': '柔軟に編集できるリッチテンプレート',
  'hero.benefit12': '受信者の登録不要',
  'hero.benefit13': 'デスクトップからモバイルまで、どの端末でも利用可能',
  'how.simpleProcess': 'シンプルな流れ',
  'how.title': '使い方',
  'how.subtitle': '3ステップで作成・送信・署名。',
  'how.step1Title': 'テンプレートを作成',
  'how.step1Desc': 'PDFのアップロード・テキスト抽出、リッチテキストエディタ、署名フィールド（日付・氏名・同意・署名ブロック）、レイアウト編集。テンプレートとして保存して再利用。',
  'how.step2Title': '宛先に送信',
  'how.step2Desc': '安全な署名リンク付きメールで送信。複数宛先に対応し、リンクをコピーして共有したり、開封・完了を追跡できます。',
  'how.step3Title': '署名済みPDFを受け取る',
  'how.step3Desc': 'タイムスタンプ・メール・電話・同意を含む監査証跡付きの署名済みPDFを受け取ります。完了時に確認メールが届きます。',
  'pricing.compareHeadline': 'なぜ電子署名に月19ドル払う必要がある？',
  'pricing.comparePlatform': 'プラットフォーム',
  'pricing.comparePrice': '料金',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/月',
  'pricing.compareBestValue': '最高の価値',
  'pricing.compareWhyPayLine1': '数秒で法的拘束力のある電子署名を送信',
  'pricing.compareWhyPayLine2': '1通以上？月額2ドルからのサブスクリプション',
  'pricing.compareBenefitSingle': '単体の書類を送信',
  'pricing.compareBenefitNoContract': '高額な契約なし',
  'pricing.compareBenefitPayWhenNeed': '必要な時だけ支払い',
  'pricing.compareBenefitTemplates': '30種類以上のテンプレートから選択',
  'pricing.compareDisclaimer': '競合価格は公開されているスターター料金に基づき、変動する場合があります。',
  'trust.secureLinks': '各ドキュメントに固有の安全な署名リンク',
  'trust.auditTrail': '各署名の完全な監査証跡（誰が、いつ、IP）',
  'trust.verifiablePdfs': '保管できる検証可能な署名済みPDF',
  'trust.footer': '世界中のフリーランサーと中小企業に信頼されています',
  'useCases.title': 'こんな方に最適（テンプレート準備完了）',
  'useCases.freelancers': '契約書を送るフリーランサー',
  'useCases.agencies': '契約に署名する代理店',
  'useCases.landlords': '賃貸契約を送る大家',
  'useCases.startups': 'NDAに署名するスタートアップ',
  'useCases.carBoat': '法的書類で車やボートを売る',
  'useCases.consultants': 'コンサルタントと個人事業主',
  'useCases.equipmentRental': '正式な契約で機器をレンタル',
  'useCases.contractors': '業務委託でクライアント業務を契約する方',
  'useCases.website': 'ウェブ・デジタルプロジェクトの契約',
  'pricing.title': '料金',
  'pricing.billAnnually': '年払い',
  'pricing.billMonthly': '月払い',
  'pricing.getStarted': '始める',
  'pricing.mostPopular': '人気',
  'pricing.billedPerYear': '${amount}/年',
  'pricing.perMonth': '/月',
  'pricing.tierBasic': 'ベーシック',
  'pricing.tierStandard': 'スタンダード',
  'pricing.tierPremium': 'プレミアム',
  'pricing.descBasic': 'たまに使う方向け。',
  'pricing.descStandard': 'チーム向け。',
  'pricing.descPremium': '高度なニーズに対応。',
  'about.label': '選ばれる理由',
  'about.title': '会社概要',
  'about.subtitle': 'プロの署名ワークフローをシンプル・迅速・安全にし、ビジネスに集中していただきます。',
  'about.speed': 'スピード',
  'about.builtForSpeed': 'スピード重視',
  'about.builtForSpeedDesc': 'モダンなUIで数分で書類を作成・送信。署名者はデスクトップ・タブレット・スマホのどの端末からも、ダウンロード不要で完了できます。',
  'about.security': 'セキュリティ',
  'about.dataSecurity': 'データセキュリティ',
  'about.dataSecurityTitle': 'Google Firebase と Google Cloud でホスト',
  'about.dataSecurityDesc': 'アカウントデータ、書類、テンプレート、署名アクティビティは Google Firebase と Google Cloud 上で処理されます。これらは本番アプリ向けの強力な認証とストレージ向けプラットフォームです。通信はHTTPS（TLS）でエンドツーエンド保護され、保存データはGoogle管理の鍵（AES-256を含む）で暗号化されます。サインインは Firebase Authentication を使用し、Firestore セキュリティルールがアカウントに一致する読み書きを保つよう支援し、ワークスペースが分離され全世界に公開されないようにします。インフラはGoogleグローバルネットワーク上で稼働し、Googleの文書に記載の監視・パッチ・耐久性の実践に従います。個人データや文書の内容をブローカーや広告主に販売することはありません。サブプロセッサ、コンプライアンス、お客様の権利についてはプライバシーポリシーをご覧ください。',
  'about.dataSecurityPrivacyCta': 'プライバシーポリシー全文を読む →',
  'about.privacyPill': 'プライバシー',
  'about.privacyFocused': 'プライバシー重視',
  'about.privacyFocusedDesc': '署名リンクは一つひとつ固有で、宛先には送信した内容だけが見えます。署名済みPDFには誰がいつ署名しどの同意をしたかという明確な監査証跡が付き、プライバシーと証明を両立できます。',
  'about.teams': '個人・チーム',
  'about.madeForTeams': '個人でもチームでも',
  'about.madeForTeamsDesc': 'リッチテキストや見出し・リストで書類を作成。署名フィールド、日付、氏名、カスタムフィールドを追加。テンプレートを保存してテンプレート履歴から読み込み。送信前にPDFプレビュー、複数宛先送信、添付ファイルやメール活動の追跡（対象プラン）。',
  'about.sectionHeadlineBefore': '',
  'about.sectionHeadlineAccent': '信頼とスピードのために設計',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'よくある質問',
  'faq.searchHint': 'キーワードで検索してFAQを素早く見つけ',
  'faq.searchPlaceholder': '例：PDF、テンプレート、署名...',
  'faq.noResults': '該当するFAQはありません。別のキーワードをお試しください。',
  'faq.more': 'もっと見る',
  'faq.less': '閉じる',
  'faq.eyebrow': 'ご不明な点は？',
  'faq.titleBefore': 'よくある',
  'faq.titleAccent': '質問',
  'faq.subtitleLead': 'Prime Document Sign について知っておくべきことのすべて。答えが見つかりませんか？ ',
  'faq.subtitleLink': 'お問い合わせください。',
  'faq.clearSearchAria': '検索をクリア',
  'faq.subscriptionsWorkQ': 'サブスクリプションはどのように機能しますか？',
  'faq.upgradePlanQ': 'プランをアップグレードするには？',
  'faq.upgradePlanA': 'マイアカウント→マイサブスクリプションで、上位プラン（スタンダードまたはプレミアム）を選択して確認。アップグレードは通常すぐに反映され、残りの請求期間分の日割り課金がある場合があります。メール・テンプレート・添付の新制限もすぐに適用されます。',
  'faq.downgradePlanQ': 'プランをダウングレードするには？',
  'faq.downgradePlanA': 'マイアカウント→マイサブスクリプションで下位プランを選択して確認。ダウングレードは次回請求周期の開始時に適用。それまでは現在のプランのまま。差額の返金はありません。',
  'faq.cancelPlanQ': 'サブスクリプションを解約するには？',
  'faq.cancelPlanA': 'マイアカウント→マイサブスクリプションでStripeのカスタマーポータルから解約するか、サポートに連絡。解約は現在の請求期間終了時に有効。それまでは利用可能。日割り返金はありません。',
  'faq.emailLimitQ': '月間メール制限に達したら？',
  'faq.yearlyBillingQ': '年払いはありますか？',
  'faq.yearlyBillingA': 'はい。プレミアムは月払いまたは年払い：${{monthly}}/月または${{annual}}/年。年払いで最大{{discountPercent}}%お得。登録時またはマイサブスクリプションで切り替え可能。',
  'faq.multipleRecipientsQ': '複数の宛先に送れますか？',
  'faq.multipleRecipientsA': 'はい。ベーシックは1回あたり最大5宛先、スタンダード・プレミアムは最大10宛先。メールをカンマ区切りで入力。各宛先に固有の署名リンクが届き、アカウント不要で完了できます。',
  'faq.reuseTemplatesQ': 'テンプレートを再利用できますか？',
  'faq.reuseTemplatesA': 'ベーシックは保存テンプレート3件、スタンダード10、プレミアム25。テンプレート履歴（マイアカウント）でいつでも読み込み。書類内容・書式・署名フィールドが保存されます。',
  'faq.recipientAccountQ': '受信者はアカウントが必要ですか？',
  'faq.recipientAccountA': 'いいえ。メールの署名リンクからそのまま端末で署名。アカウント不要。デスクトップ・タブレット・スマホで利用可能。',
  'faq.confirmationEmailQ': '確認メールは届きますか？',
  'faq.confirmationEmailA': 'はい。書類完了時に署名済みPDF付きの確認メールが自動送信。各PDFには監査証跡（タイムスタンプ・メール・電話・同意）が含まれます。',
  'faq.previewPdfQ': '送信前にPDFをプレビューできますか？',
  'faq.previewPdfA': 'はい。プレビューPDFボタンで送信前のレイアウトを確認。書式・余白・内容を確認してから送信またはリンクをコピー。',
  'faq.editAgreementQ': '契約文を編集できますか？',
  'faq.editAgreementA': 'はい。リッチテキストエディタで見出し・リスト・太字・斜体・下線・フォントサイズを調整。PDFをアップロードしてテキスト抽出や全文表示も可能。',
  'faq.signatureRequiredQ': '送信には署名は必須ですか？',
  'faq.signatureRequiredA': 'はい。受信者は日付・氏名・同意チェック・署名を完了する必要があります。法的有効性を満たします。',
  'faq.attachmentsQ': '添付はいくつまで？',
  'faq.attachmentsA': 'ベーシックは添付不可。スタンダードは1通あたり最大3（合計8MB）、プレミアムは最大10（合計8MB）。署名リンクと一緒に送信されます。',
  'faq.emailActivityQ': 'メール活動・制限（プレミアム）とは？',
  'faq.emailActivityA': 'プレミアムではマイアカウントからメール送信活動を確認。どの書類をいつ誰に送ったか。コンプライアンスや記録に便利。',
  'faq.emailRemindersQ': 'メールリマインダーはどう動きますか？',
  'faq.emailRemindersA': 'ドキュメントビルダーのステップ4（追加機能）で、各送信につき1日・3日・7日のリマインダーをオンにできます。最初の署名メール送信後、その宛先がまだ完了していない場合にのみリマインダーを送ります。署名が完了すると自動で停止します。リマインダーメールはメール活動に日時付きで表示され、月間メール送信上限には含まれません。',
  'faq.defaultSenderQ': 'デフォルトの送信元メールを設定できますか？',
  'faq.defaultSenderA': 'はい。マイアカウント→アカウント詳細で希望のメールを入力して保存。送信時に「差出人」に自動入力されます。',
  'faq.mobileSignQ': '受信者はスマホで署名できますか？',
  'faq.mobileSignA': 'はい。レスポンシブ対応。スマホやタブレットでリンクを開き、指やスタイラスで署名して完了。',
  'faq.getHelpQ': 'ヘルプはどう受けられますか？',
  'faq.getHelpA': 'マイアカウントのサポート連絡またはウェブサイトのお問い合わせフォームから。できるだけ早く返信します。',
  'faq.dataSecureQ': 'データは安全ですか？',
  'faq.dataSecureA': 'はい。業界標準の方法で書類と個人情報を保護。安全に送信・保存されます。',
  'faq.fileFormatsQ': '対応ファイル形式は？',
  'faq.fileFormatsA': '書類はリッチテキストエディタで作成。完了契約はPDFで出力され、法的・ビジネス用途で広く利用可能。',
  'faq.deleteTemplateQ': 'テンプレートを削除すると？',
  'faq.deleteTemplateA': '削除したテンプレートは復元できません。削除前に不要か確認を。現在の書類からいつでも新規テンプレートを作成できます。',
  'faq.ownLogoQ': '自分のロゴを追加できますか？',
  'faq.ownLogoA': 'スタンダードとプレミアムで可能。ロゴ（最大20KB）をアップロードして位置を選択。署名ページと署名済みPDFに表示。ベーシックには含まれません。',
  'faq.uploadPdfQ': 'PDFはどうやってアップロードしますか？',
  'faq.uploadPdfA': 'ドキュメントビルダーで「PDFをアップロード」オプション（スタンダード・プレミアム）を使用。PDFは契約文の上または横に表示。受信者は署名時に全文を確認できます。',
  'faq.extractPdfQ': 'PDF抽出とは？どのように機能しますか？',
  'faq.extractPdfA': 'PDF抽出（スタンダード・プレミアム）は既存PDFのテキストをエディタに取り込んで編集できます。PDFをアップロードし「テキストを抽出」を選択すると内容がコピーされます。編集後、署名フィールドを追加可能。',
  'faq.richTextEditorQ': 'リッチテキストエディタで何ができますか？',
  'faq.richTextEditorA': '見出し、太字、斜体、リスト、フォントサイズで契約を作成・編集。署名ブロックを下に追加。コーディング不要、すべてクリック操作で完了。',
  'faq.previewWhenQ': '送信前にいつプレビューすべきですか？',
  'faq.previewWhenA': '送信前は必ず「PDFプレビュー」を使用。受信者が見るレイアウトを正確に表示：契約文、署名ブロック、日付、氏名。書式を確認してから送信またはリンクをコピー。',
  'faq.documentLifetimeQ': '署名リンクはどのくらい有効ですか？延長は可能ですか？',
  'faq.documentLifetimeA': 'リンクは通常、作成から約30日間有効。期限前に署名済みPDFをダウンロードして保存。期限切れの場合は送信者に連絡し、新しいメールとリンクを依頼してください。',
  'faq.editLayoutQ': '署名レイアウトはどう編集しますか？',
  'faq.editLayoutA': '署名セクションの「レイアウトを編集」でフィールドを並べ替え。日付、氏名、条件、署名ブロック、カスタムフィールドをドラッグ＆ドロップ。スペーサー追加や列数も選択可能。',
  'faq.customFieldsQ': 'カスタムフィールド（テキスト、日付、チェックボックス等）はどう追加しますか？',
  'faq.customFieldsA': '署名セクションで「カスタムフィールドを追加」をクリック。ラベルとタイプ（テキスト、数値、日付、時間、リスト、チェックボックス、署名）を選択。最大10フィールド。どの署名者が各フィールドを見るか指定し、レイアウト編集で配置。',
  'faq.multipleSignaturesQ': '2人以上の署名（複数署名者）を追加できますか？',
  'faq.multipleSignaturesA': 'はい。受信者セクションで2人目の署名者を追加。各自が固有のリンクと署名ブロックを受け取ります。ベーシックは最大5人、スタンダード・プレミアムは最大10人まで。',
  'faq.documentBuilderTipsQ': 'ドキュメントビルダーで何ができますか？',
  'faq.documentBuilderTipsA': '契約作成、PDFアップロード・抽出、署名ブロック・カスタムフィールド・添付ファイルの追加。レイアウト編集、テンプレート保存、PDFプレビュー。変更は自動保存されます。',
  'faq.clearEverythingQ': '「すべてクリア」は何をしますか？',
  'faq.clearEverythingA': '「すべてクリア」はビルダーをリセット：契約文、署名ブロック、カスタムフィールド、添付ファイルを削除。新規ドキュメントを最初から作成する際に使用。保存済みテンプレートは影響を受けません。',
  'faq.forgotPasswordQ': 'パスワードを忘れました。どうリセットしますか？',
  'faq.forgotPasswordA': 'ログイン画面で「パスワードをお忘れですか？」をクリック。メールアドレスを入力してリセットリンクを送信。受信トレイ（と迷惑メール）を確認。リンクは期限切れになるので、必要なら新しいリンクをリクエスト。新しいパスワードでログイン。',
  'faq.saveTemplateQ': 'ドキュメントをテンプレートとして保存するには？',
  'faq.saveTemplateA': 'ドキュメントを作成し、「テンプレートを保存」をクリック。名前を付けて「新規として保存」。マイアカウントのテンプレート履歴に表示。更新時：テンプレートを読み込み、編集し、テンプレートを保存→テンプレートを更新。',
  'faq.loadTemplateQ': 'テンプレート履歴からテンプレートを読み込むには？',
  'faq.loadTemplateA': 'マイアカウント→テンプレート履歴。読み込みたいテンプレートをクリック。ビルダーで全文とレイアウトが開く。必要に応じて編集、受信者を追加して送信。',
  'faq.templateLimitsQ': 'テンプレートはいくつ保存できますか？',
  'faq.templateLimitsA': 'ベーシック：3、スタンダード：10、プレミアム：25個。各テンプレートはテキスト、書式、署名ブロック、レイアウトを保存。上限時：古いものを削除するかプランをアップグレード。',
  'faq.recipientNoEmailQ': '受信者が署名メールを受け取っていない場合は？',
  'faq.recipientNoEmailA': '迷惑メールフォルダを確認してもらう。リンクをコピーしてURLを取得し、手動で共有（SMS、Slackなど）。または同じメールにドキュメントを再送して新しいリンクを発行。',
  'faq.editAfterSendQ': '送信後にドキュメントを編集できますか？',
  'faq.editAfterSendA': 'いいえ。送信後は内容はロックされます。変更するには：更新内容で新しいドキュメントを作成して再送信。未送信の下書きは自由に編集可能。',
  'faq.changeAccountQ': 'メールやパスワードを変更するには？',
  'faq.changeAccountA': 'マイアカウント→アカウント詳細。メールまたはパスワードを更新。パスワード変更時：現在のパスワードと新しいパスワードを入力。現在のパスワードを忘れた場合はログイン画面の「パスワードをお忘れですか？」を使用。',
  'faq.browserSupportQ': '対応ブラウザとデバイスは？',
  'faq.browserSupportA': 'Chrome、Firefox、Safari、Edge（デスクトップ・モバイル）。署名はレスポンシブ—スマホ・タブレット対応。最新版のブラウザを推奨。アプリのダウンロード不要。',
  'faq.copyLinkQ': 'メールではなくリンクをコピーして共有するには？',
  'faq.copyLinkA': 'ドキュメント作成後、「リンクをコピー」をクリック。URLがクリップボードにコピーされる。メッセージ、メール、Slackに貼り付け。受信者は当社からのメールなしで署名可能。',
  'faq.resendDocumentQ': '受信者がまだ署名していない場合、ドキュメントを再送できますか？',
  'faq.resendDocumentA': 'はい。同じドキュメントを同じまたは別のメールに再送信可能。各送信で新しいリンクが作成される。元のリンクが期限切れの場合、再送で新しいリンクを発行。メール活動（プレミアム）で送信状況を確認可能。',
  'testimonials.eyebrow': 'お客様の声',
  'testimonials.title': 'お客様からの評価',
  'testimonials.quote1': 'コストは業界最安レベル。いくつか比較して、Prime Document Signが一番コスパが良く、使いやすいです。',
  'testimonials.quote2': 'ChatGPTで契約文を作り、数分で編集して署名依頼を送りました。10分もかかりませんでした。',
  'testimonials.quote3': 'スマホだけで完結。通勤中に書類を作成し、署名フィールドを入れて送信。とても便利です。',
  'testimonials.quote4': '使いやすく料金も公正。隠し料金なし。チームで契約やNDAに使っていますが、みんなすぐに慣れました。',
  'testimonials.quote5': '契約文を貼り付けて署名ブロックを入れて送っただけ。受信者が当日署名。まさに欲しかった機能です。',
  'testimonials.quote6': 'PCとスマホの両方で利用。どちらも快適。電子署名では最高のコスパだと思います。',
  'testimonials.prev': '前へ',
  'testimonials.next': '次へ',
  'contact.title': 'お問い合わせ',
  'contact.subtitle': 'ご質問がありますか？お気軽にご連絡ください。',
  'contact.eyebrow': 'お問い合わせ',
  'contact.headlineBefore': 'ぜひ',
  'contact.headlineAccent': 'お話ししましょう',
  'contact.responseTimeLabel': '返信目安',
  'contact.responseTimeValue': '24時間以内',
  'contact.secureLabel': '安全・非公開',
  'contact.secureValue': 'AES-256 暗号化',
  'contact.trustNoSpam': 'スパムは一切ありません',
  'contact.trustHumanSupport': '人間によるサポート',
  'contact.firstName': '名',
  'contact.lastName': '姓',
  'contact.email': 'メール',
  'contact.message': 'メッセージ',
  'contact.sendMessage': '送信',
  'contact.required': '*',
  'contact.placeholderFirst': '名を入力',
  'contact.placeholderLast': '姓を入力',
  'contact.placeholderEmail': 'メールアドレスを入力',
  'contact.placeholderMessage': 'ご用件をお書きください...',
  'contact.attachments': '添付ファイル',
  'contact.attachmentsHint': '最大5ファイル、合計2MB',
  'contact.addFiles': '+ ファイルを追加',
  'contact.addAttachmentsAria': '添付を追加',
  'auth.forgotPassword': 'パスワードをお忘れですか？',
  'auth.backToLogIn': 'ログインに戻る',
  'auth.sendResetLink': 'リセットリンクを送信',
  'auth.checkEmailReset': 'メールでリセットリンクをご確認ください。',
  'auth.emailLabel': 'メール',
  'auth.passwordLabel': 'パスワード',
  'auth.firstNameLabel': '名',
  'auth.lastNameLabel': '姓',
  'auth.enterEmail': 'メールアドレスを入力してください。',
  'auth.enterEmailPassword': 'メールとパスワードを入力してください。',
  'auth.passwordMinLength': 'パスワードは8文字以上にしてください。',
  'auth.passwordSpecial': 'パスワードに特殊文字を含めてください。',
  'auth.passwordsNoMatch': 'パスワードが一致しません。',
  'auth.signInWithGoogle': 'Googleでログイン',
  'auth.or': 'または',
  'auth.logInFailed': 'ログインに失敗しました。',
  'auth.signUpFailed': '登録に失敗しました。',
  'auth.emailAlreadyInUse': 'このメールアドレスは既に使用されています。',
  'connectionError.message': '接続に問題があります。インターネット接続を確認し、ページを再読み込みしてください。',
  'connectionError.refresh': 'ページを再読み込み',
  'connectionError.tooManyRequests': '試行回数が多すぎます。しばらくしてから再試行してください。',
  'auth.emailPlaceholder': 'john@example.com',
  'auth.passwordPlaceholder': 'パスワードを入力',
  'auth.firstNamePlaceholder': '太郎',
  'auth.lastNamePlaceholder': '山田',
  'auth.manageSubscription': 'サブスクリプションを管理',
  'auth.subscribe': 'サブスクリプション',
  'auth.signUpForSubscription': 'サブスクリプションに登録',
  'auth.currentPlan': '現在のプラン',
  'auth.updatePlanHint': 'Stripeでプランを更新すると月間クレジットが増えます。アップグレード後に新制限が適用されます。',
  'auth.updatePlanStripe': 'Stripeのセキュアポータルでプラン・支払い方法の変更や解約ができます。',
  'auth.subscribeToPlan': 'プランに登録して始めましょう。',
  'auth.topUpCredits': '代わりにクレジットを追加（{{label}}: ${{price}}）',
  'pricing.featureRecipients5': '1回あたり最大5宛先',
  'pricing.featureRecipients10': '1回あたり最大10宛先',
  'pricing.featureEmails5': '月最大5通',
  'pricing.featureEmails50': '月最大100通',
  'pricing.featureEmails150': '月最大300通',
  'pricing.featureTemplates3': '保存テンプレート3件',
  'pricing.featureTemplates10': '保存テンプレート10件',
  'pricing.featureTemplates25': '保存テンプレート25件',
  'pricing.featureChars3k': '3,000文字まで',
  'pricing.featureChars20k': '20,000文字まで',
  'pricing.featureChars30k': '30,000文字まで',
  'pricing.featureAttachmentsNone': '添付なし',
  'pricing.featureAttachments3': '添付3件（合計8MB）',
  'pricing.featureAttachments10': '添付10件（合計8MB）',
  'pricing.featurePdfUpload': 'PDF全文アップロード',
  'pricing.featureAuditTrail': '監査証跡',
  'pricing.featurePdfExtract': 'PDFテキスト抽出・編集',
  'pricing.featureCustomFields': 'カスタムフィールド作成・レイアウト編集',
  'pricing.featureCopyLink': '署名リンクをコピー',
  'pricing.featureLogo': 'カスタムロゴアップロード',
  'pricing.featureVerification': '受信者確認',
  'app.createYourDocument': '書類を作成',
  'app.backToApp': 'アプリに戻る',
  'app.backToMainSite': 'メインサイトに戻る',
  'app.backShort': '戻る',
  'app.myAccount': 'マイアカウント',
  'app.saveTemplate': 'テンプレートを保存',
  'app.templatesUsed': '使用中のテンプレート',
  'app.templatesUsedSaved': '{{count}} 件のテンプレートを保存',
  'app.startFromTemplate': 'テンプレートから開始',
  'app.startFromTemplateHint': 'ドキュメントに記入するテンプレートを選択してください。選択後に編集できます。',
  'app.signedInAs': 'ログイン中',
  'app.sendCredits': '送信クレジット',
  'app.freeSendBanner': '無料のメール送信が1回あります — 署名依頼にご利用ください。いつでもプランに加入して追加できます。',
  'app.creditEqualsSend': '1クレジット = 1通送信',
  'app.topUpCredits': 'クレジット追加',
  'app.emailSends': '通送信',
  'app.signedAgreements': '署名済み契約',
  'app.usedAfterAllowance': '（月間枠超過後）',
  'app.sendForSignature': '署名のため送信',
  'app.recipientsSection': '送信先',
  'app.fromNameOrg': '送信者名 / 組織',
  'app.fromNamePlaceholder': '名前または組織名',
  'app.fromEmail': '送信元メール',
  'app.fromEmailPlaceholder': '送信元メールアドレス',
  'app.recipientEmail': '宛先メール',
  'app.recipientHint': 'カンマ区切り、最大{{max}}件',
  'app.recipientPlaceholder': '宛先メールアドレス',
  'app.recipientTooltip': '例: a@b.com, c@d.com',
  'app.previewPdf': 'PDFプレビュー',
  'app.clearEverything': 'すべてクリア',
  'app.clearEverythingTitle': 'ドキュメント・宛先・下書きをクリア',
  'app.copyLink': 'リンクをコピー',
  'app.copyLinkSubscribersOnly': 'リンクをコピー（登録ユーザー向け）',
  'app.generatingLink': 'リンクを生成中…',
  'app.sendEmail': 'メール送信',
  'app.agreementText': '契約文',
  'app.uploadPdfExtract': 'PDFをアップロードしてテキスト抽出',
  'app.fullPdfUpload': 'PDF全文アップロード',
  'app.agreementPlaceholder': 'ここをクリックして契約文を作成...',
  'app.attachments': '添付ファイル',
  'app.attachmentsHint': '最大10ファイル、合計8MBまで。',
  'app.addAttachment': '+ 添付を追加',
  'app.signatureSection': '署名欄',
  'app.totalSignatures': '署名数',
  'app.createNewField': '新規フィールド作成',
  'app.addField': 'フィールドを追加',
  'app.layout': 'レイアウト',
  'app.editLayout': 'レイアウトを編集',
  'app.addFieldTooltip': '署名ブロックにカスタムフィールド（テキスト・日付・チェック・署名）を追加。最大{{max}}個。',
  'app.date': '日付',
  'app.datePlaceholder': 'yyyy/mm/dd',
  'app.termsConditions': '利用規約への同意',
  'app.fullName': '氏名',
  'app.fullNamePlaceholder': '氏名を入力',
  'app.signature': '署名',
  'app.clickToSign': 'クリックして署名',
  'app.termsAgree': '利用規約に同意します。',
  'app.phone': '電話番号',
  'app.phonePlaceholder': '電話番号を入力',
  'app.enterFieldPlaceholder': '{{label}}を入力',
  'app.enterNumber': '数値を入力',
  'app.selectOption': '選択...',
  'app.noFields': 'フィールドなし',
  'app.newDocument': '新規ドキュメント',
  'app.templateLabel': 'テンプレート: {{name}}',
  'app.forSubscribersOnly': '登録ユーザー向け',
  'app.emailCredits': 'メールクレジット',
  'app.creditHintDeliver': '1クレジット = 1通送信 — 送信をクリック',
  'app.skipAuthTesting': '認証をスキップ（テスト用）',
  'app.agreementRequired': '契約文またはPDFのアップロードが必要です。',
  'app.agreementOrPdfRequired': '契約文またはPDFが必要です。',
  'app.loadingPdf': 'PDFを読み込み中…',
  'app.clearConfirmTitle': 'すべてクリア',
  'app.clearConfirmMessage': 'すべてのフィールドと添付をクリアしますか？',
  'app.cancel': 'キャンセル',
  'app.clear': 'クリア',
  'app.clearConfirmButton': 'はい、すべてクリア',
  'footer.tagline': 'モダンなユーザーのためのセキュアな電子署名。',
  'footer.product': '製品',
  'footer.templates': 'テンプレート',
  'footer.company': '会社',
  'footer.contactSupport': 'サポートに連絡',
  'footer.copyright': '© 2026 primedocumentsign. All rights reserved.',
  'footer.terms': '利用規約',
  'footer.privacy': 'プライバシーポリシー',
  'auth.logIn': 'ログイン',
  'auth.loggingIn': 'ログイン中…',
  'auth.getStarted': '始める',
  'auth.signUp': '登録',
  'auth.logInToManage': 'ログインして書類の管理・送信を行います。',
  'auth.startSending': 'シンプルなサブスクリプションで送信を開始。',
  'auth.termsConfirmStart': '',
  'auth.termsConfirmEnd': ' を読み、その内容に同意します。',
  'auth.termsMustAccept': 'アカウントを作成するには利用規約に同意してください。',
  'email.signSubject': 'この契約に署名してください',
  'email.signTitle': '署名する書類',
  'email.signSubtitle': '書類の署名をご依頼しています',
  'email.fromLabel': '差出人',
  'email.signBody': '下のボタンをクリックして書類を開き、署名を追加してください。アカウントや契約は不要です。',
  'email.signButton': '書類に署名する',
  'email.copyLink': 'または次のリンクをコピー:',
  'email.ignoreNote': '心当たりがない場合は、このメールを無視してかまいません。',
  'modal.editFieldLayout': 'フィールドレイアウトを編集',
  'modal.editFieldLayoutHint': 'フィールドをドラッグして並べ替えたり列間で移動できます。',
  'modal.columns': '列',
  'modal.col': '{{n}}列',
  'modal.addSpace': 'スペースを追加',
  'modal.fields': 'フィールド',
  'modal.leftColumn': '左列',
  'modal.rightColumn': '右列',
  'modal.removeFromLayout': 'レイアウトから「{{name}}」を削除しますか？',
  'modal.space': 'スペース',
  'modal.yesRemove': 'はい、削除',
  'modal.keepIt': '残す',
  'modal.emptySpace': '空きスペース',
  'modal.dropFieldsHere': 'ここにフィールドをドロップ',
  'modal.removedFromLayout': 'レイアウトから削除 — + で復元',
  'modal.saveLayout': 'レイアウトを保存',
  'modal.removeFromLayoutTitle': 'レイアウトから削除',
  'modal.restoreToLayout': 'レイアウトに復元',
  'modal.editCustomField': 'カスタムフィールドを編集',
  'modal.editCustomFieldHint': 'ラベル、タイプ、または表示する署名者を変更できます。',
  'modal.addCustomField': 'カスタムフィールドを追加',
  'modal.addCustomFieldHint': '署名フォームに含める新しいフィールドを作成。最大10個。',
  'modal.fieldLabel': 'フィールドラベル',
  'modal.fieldLabelPlaceholder': '例：会社名',
  'modal.fieldType': 'フィールドタイプ',
  'modal.displayContent': '表示内容（受信者には読み取り専用、最大100文字）',
  'modal.displayContentPlaceholder': '例：以下の条件をご確認ください',
  'modal.picklistOptions': '選択肢（最大10件）',
  'modal.typeAndPressAdd': '入力して「追加」を押す',
  'modal.add': '追加',
  'modal.addedToSignature': '署名に追加',
  'modal.addedToSignatureHint': '下のチェックボックスで署名レイアウトに追加',
  'modal.signature1': '署名1',
  'modal.signature2': '署名2',
  'modal.close': '閉じる',
  'modal.save': '保存',
  'modal.fieldLabelRequired': 'フィールドラベルは必須です',
  'modal.displayContentRequired': 'テキスト表示には表示内容が必須です',
  'modal.picklistOptionRequired': '選択肢を1つ以上追加してください',
  'modal.selectOneSignature': '署名を1つ以上選択してください',
  'modal.signingSectionExceed': '署名セクションが{{limit}} KBを超えます。内容を減らしてください。',
  'modal.link': 'リンク',
  'modal.linkTitle': 'リンクタイトル',
  'modal.linkUrl': 'リンクURL',
  'modal.linkTextPlaceholder': 'リンクテキスト',
  'modal.linkUrlPlaceholder': 'https://example.com',
  'modal.agreementSizeLimitReached': '契約サイズ上限に達しました',
  'modal.characterLimitReached': '文字数上限に達しました',
  'modal.agreementSizeLimitMessage': '契約の最大サイズ（{{max}} KB）に達しました。追加前に内容や画像を減らしてください。',
  'modal.characterLimitMessage': '最大文字数（{{max}}文字）に達しました。追加前にテキストを減らしてください。',
  'modal.signingSectionLimitReached': '署名セクション上限に達しました',
  'modal.signingSectionLimitMessage': '署名セクションの最大サイズ（{{limit}} KB）に達しました。フィールド・署名・カスタムフィールドを減らしてください。',
  'modal.ok': 'OK',
  'modal.addYourSignature': '署名を追加',
  'modal.signatureHint': 'マウスまたはトラックパッドで署名してください。',
  'modal.clear': 'クリア',
  'modal.saveSignature': '署名を保存',
  'modal.removeAttachment': '添付を削除',
  'modal.removeAttachmentConfirm': '「{{name}}」をこのドキュメントから削除しますか？',
  'modal.yesRemoveLabel': 'はい、削除',
  'modal.removeLogo': 'ロゴを削除',
  'modal.removeLogoConfirm': 'このドキュメントからロゴを削除しますか？',
  'modal.textDisplay': 'テキスト表示',
  'modal.picklist': '選択リスト',
  'modal.number': '数値',
  'modal.time': '時刻',
  'modal.editLabel': 'ラベルを編集',
  'modal.editField': 'フィールドを編集',
  'modal.text': 'テキスト',
  'modal.checkbox': 'チェックボックス',
  'modal.date': '日付',
  'modal.signature': '署名',
  'modal.typeHasDataHint': 'このフィールドにデータがあるためタイプは変更できません。',
  'modal.typeHasDataTitle': 'データがあるフィールドのタイプは変更できません',
  'modal.noKeepIt': 'いいえ、残す',
  'modal.yesDelete': 'はい、削除',
  'modal.deleteTemplate': 'テンプレートを削除',
  'modal.deleteTemplateConfirm': '「{{name}}」を削除しますか？元に戻せません。',
  'modal.removeAttachmentFromMessage': 'メッセージから「{{name}}」を削除しますか？',
  'modal.readyToSend': '送信しますか？',
  'modal.recipientsLabel': '宛先：',
  'modal.readyToSendSubtitle': 'ドキュメントをプレビューし、送信する準備ができていますか？次の宛先に送信されます：',
  'modal.no': 'いいえ',
  'modal.yesSend': 'はい、送信',
  'modal.accountAlreadyExists': 'アカウントは既に存在します',
  'modal.accountAlreadyExistsMessage': 'このメールは既に登録されています。ログインしますか？別のメールで登録しますか？',
  'modal.useDifferentEmail': '別のメールを使う',
  'modal.logIn': 'ログイン',
  'modal.logOut': 'ログアウトしますか？',
  'modal.logOutSubtitle': 'ログアウトしてもよろしいですか？',
  'modal.yesLogOut': 'はい、ログアウト',
  'lang.en': 'English',
  'lang.es': 'Spanish',
  'lang.pt': 'Portuguese',
  'lang.ja': '日本語',
  'lang.zh': 'Chinese',
  'lang.hi': 'Hindi',
  'lang.fr': 'French',
  'lang.it': 'Italian',
  'lang.de': 'German',

  'templates.starter.nda.name': '秘密保持契約（NDA）',
  'templates.starter.nda.scopeTitle': '秘密保持契約',
  'templates.starter.freelance.name': 'フリーランス業務委託契約',
  'templates.starter.freelance.scopeTitle': 'フリーランス業務委託契約',
  'templates.starter.vehicle.name': '車両売買契約',
  'templates.starter.vehicle.scopeTitle': '車両売買契約',
  'templates.starter.rental.name': '住宅賃貸契約',
  'templates.starter.rental.scopeTitle': '住宅賃貸契約',
  'templates.starter.recruitment.name': '人材紹介サービス契約',
  'templates.starter.recruitment.scopeTitle': '人材紹介サービス契約',
  'templates.starter.loan.name': 'ローン契約',
  'templates.starter.loan.scopeTitle': 'ローン契約',
  'templates.starter.website.name': 'ウェブサイト開発契約',
  'templates.starter.website.scopeTitle': 'ウェブサイト開発契約',
  'templates.starter.roommate.name': 'ルームメイト契約',
  'templates.starter.roommate.scopeTitle': 'ルームメイト契約',
  'templates.starter.photography.name': '写真撮影サービス契約',
  'templates.starter.photography.scopeTitle': '写真撮影サービス契約',
  'templates.starter.shortterm-rental.name': '短期賃貸契約',
  'templates.starter.shortterm-rental.scopeTitle': '短期賃貸契約',
  'templates.starter.equipment-rental.name': '機器レンタル契約',
  'templates.starter.equipment-rental.scopeTitle': '機器レンタル契約',
  'templates.starter.independent-contractor.name': '業務委託契約',
  'templates.starter.independent-contractor.scopeTitle': '業務委託契約',
}
